import { lazy } from 'react';

import type { AppRouteConfig } from '@/App/AppRoutes/types';

const DeleteAccountTokenInvalidPage = lazy(() =>
  import('@/components/pages/DeleteAccount/DeleteAccountTokenInvalidPage').then(
    ({ DeleteAccountTokenInvalidPage }) => ({
      default: DeleteAccountTokenInvalidPage,
    }),
  ),
);

export const DeleteAccountTokenInvalidRoute: AppRouteConfig = {
  key: 'delete-account-token-invalid-page',
  path: '/delete_account_token_invalid/:locale?',
  component: DeleteAccountTokenInvalidPage,
};
